import { ref as a } from "vue";
function g({
  fn: d,
  collate: i,
  fallback: s = null,
  flushOnError: v
}) {
  const e = a(s ?? null), f = a(), t = a(), r = a(0), c = [];
  let l = null;
  async function h(n) {
    var u;
    t.value = !0, l && ((u = l.cancel) == null || u.call(l));
    try {
      const o = d(n);
      l = o;
      const m = await o;
      if (o !== l) return;
      L(m);
    } catch (o) {
      p(o);
    } finally {
      t.value = !1;
    }
  }
  function p(n) {
    console.error(n), f.value = n, v && (e.value = s ?? null);
  }
  function L(n) {
    i && e.value ? e.value = i(e.value, n) : e.value = n;
    for (const u of c)
      u(n);
    r.value = r.value + 1;
  }
  function y(n) {
    c.push(n);
    function u() {
      c.filter((o) => o !== n);
    }
    return u;
  }
  return {
    data: e,
    pending: t,
    error: f,
    load: h,
    onLoad: y,
    executionCount: r
  };
}
export {
  g as useLoader
};
